module.exports = __webpack_public_path__ + "img/LAPTOP.a977d6d4.jpg";